<template>
    <div>
        <card>
            <div class="row">
                <div class="col">
                    <h1 style="color:#00467f;text-align:left;font-weight:bold">Nota di Credito</h1>
                    <!-- <button class="btn float-left" style="background:#00467f" v-on:click="esportaCSV()">Esporta</button> -->
                    <a :href="urlRichieste + 'accredito/csv?token=' + access_token" v-if="user_livello == 1 || user_livello == 2" target="_blank" style="color:white;font-weight: bold;"><button class="btn float-left" type="button" style="margin-bottom: 10px;background:#00467f">Scarica CSV</button></a>
                </div>
                <div class="col">
                    <span class="float-right" style="margin-right:20px">
                        <div class="search-bar input-group"  @click="searchModalVisible = true">
                            <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
                            <span class="d-lg-none d-md-block">Search</span>
                            </button>
                        </div>
                        <modal :show.sync="searchModalVisible"
                                class="modal-search"
                                id="searchModal"
                                :centered="false"
                                :show-close="true">
                            Cerca per:<br>
                            <label for="denominazione" style="margin-right:10px"><input type="radio" id="denominazione" value="denominazione" v-model="cerca_selezionato" style="margin-right:5px">denominazione</label>
                            <label for="dipendente"><input type="radio" id="dipendente" value="dipendente" v-model="cerca_selezionato" style="margin-right:5px">nome dipendente</label>
                            <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
                        </modal>
                    </span>
                </div>
            </div>
            <div class="row" style="margin-left:5px;margin-bottom:10px">
                <span class="float-left">
                    <router-link v-if="user_livello == 2 || user_livello == 3" :to="'/crea-nota'"><button class="btn" type="button" style="background:#00467f">Crea Nota di Credito</button></router-link>
                </span>
            </div>
            
            <div class="row">
                <div class="col-5">
                    <p style="text-align:left; margin-left:20px">FILTRA PER:<br>
                    <ul style="list-style-type: none;">
                        <!-- <li>
                            <label style="color:black"><input type="radio" value="filtraStato" v-model="filtroScelto" style="text-align:left; margin-right:10px">STATO</label>
                            <div class="row" v-if="filtroScelto == 'filtraStato'" style="margin-left:15px"><br>
                                <select v-model="stato_selected" v-on:change="filtra()" style="border: 2.5px solid;border-radius: 0.25em;border-color:#00467f;background-color: #fff;width: 100%;max-width: 100px;margin-left:30px">
                                    <option disabled value="">Please select one</option>
                                    <option>Tutti</option>
                                    <option value="autorizzata">AUTORIZZATA</option>
                                    <option value="emessa">EMESSA</option>
                                    <option value="non_ancora_autorizzata">NON ANCORA AUTORIZZATA</option>
                                    <option value="non_autorizzata">NON AUTORIZZATA</option>
                                </select>
                            </div>
                        </li> -->
                        <li>
                            <label style="color:black"><input type="radio" value="dataTermine" v-model="filtroScelto" style="text-align:left; margin-right:10px">DATA TERMINE ULTIMA EMISSIONE</label>
                            <div class="row" style="margin-left:10px;margin-bottom:25px" v-if="filtroScelto == 'dataTermine'">
                                <div class="col">
                                    <p><strong>Tra</strong><input type="date" class="form-control" value="17-06-2021" v-model="dateFrom" v-on:keyup.enter="filtra()"/></p>
                                </div>
                                <div class="col">
                                    <p><strong>e</strong><input type="date" class="form-control" value="20-08-2021" v-model="dateTo" v-on:keyup.enter="filtra()"/></p>
                                </div>
                                <div class="col">
                                    <button class="btn btn-primary" type="button" v-on:click="filtra()" style="background:#00467f;margin-top:15px">Cerca</button>
                                </div>
                            </div>
                        </li>
                        <!-- <li><label style="color:black"><input type="radio" value="filtraAutorizzate" v-model="filtroScelto" style="text-align:left; margin-right:10px" v-on:click="filtra()">NOTE AUTORIZZATE</label></li> -->
                        <li>
                            <label style="color:black"><input type="radio" value="filtraMetodoPagamento" v-model="filtroScelto" style="text-align:left; margin-right:10px">METODO DI PAGAMENTO</label>
                            <div class="row" v-if="filtroScelto == 'filtraMetodoPagamento'" style="margin-left:15px"><br>
                                <select v-model="metodo_selected" v-on:change="filtra()" style="border: 2.5px solid;border-radius: 0.25em;border-color:#00467f;background-color: #fff;width: 100%;max-width: 100px;margin-left:30px">
                                    <option disabled value="">Please select one</option>
                                    <option value="contanti">Contanti</option>
                                    <option value="bonifico">Bonifico</option>
                                    <option value="sepa">SEPA</option>
                                    <option value="pos">POS</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                    </p>
                </div>
                <!-- <div class="col text-md-center float-center" style=" margin-bottom: 15px;"> -->
                <div class="col-5">
                    <!--<legenda />-->
                    <div style="border: 2px solid;color:#00467f">
                        <h4 class="card-title" style="color:#00467f">LEGENDA</h4>
                        <div class="row">
                            <!-- blu -> nota creata, gialla -> nota approvata, verde -> nota emessa, rossa -> nota respinta -->
                            <div class="col" style="text-align:center;margin-bottom:5px"><button v-on:click="filterByStatus('non_ancora_autorizzata')" type="button" style="border: none;background:#ffffff"><img src="@/assets/img/blue.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">NOTA CREATA({{accredito_creata}})</i></button></div>
                            <div class="col" style="text-align:center;margin-bottom:5px"><button v-on:click="filterByStatus('autorizzata')" type="button" style="border: none;background:#ffffff"><img src="@/assets/img/yellow.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">NOTA APPROVATA({{accredito_approvata}})</i></button></div>
                        </div>
                        <div class="row">
                            <div class="col" style="text-align:center;margin-bottom:5px"><button v-on:click="filterByStatus('emessa')" type="button" style="border: none;background:#ffffff"><img src="@/assets/img/green.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">NOTA EMESSA({{accredito_emessa}})</i></button></div>
                            <div class="col" style="text-align:center;margin-bottom:5px"><button v-on:click="filterByStatus('non_autorizzata')" type="button" style="border: none;background:#ffffff"><img src="@/assets/img/red.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">NOTA RESPINTA({{accredito_respinta}})</i></button></div>
                        </div>
                    </div>
                </div>
                <div class="col-2"></div>
            </div>
            <!-- <hr> -->
            <div class="row" style="margin-top:10px">
                <div class="col float-left" style="font-weight:bold">
                    <label class="float-left">Numero di righe per pagina:</label>
                    <select v-model="n_righe" v-on:change="caricaPagina()" class="float-left" style="border: 2.5px solid;border-radius:0.25em;border-color:#00467f;background-color: #fff;width:100%;max-width: 100px;margin-left:30px">
                        <option disabled value="">Please select one</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div class="row justify-content-center" style="margin-bottom:30px;margin-top:20px">
              <div class="col-4">
                <div v-if="page != 1"><button v-on:click="changePage('indietro')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-left" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
              <div class="col-4">
                <p>Pagina <strong>{{page}}</strong> di <strong>{{totPage}}</strong></p>
              </div>
              <div class="col-4">
                <div v-if="page < totPage"><button v-on:click="changePage('avanti')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-right" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
            </div>
            <table class="table tablesorter" id="tabella" style="text-align: center">
                <thead>
                    <tr>
                        <th @click="sort('createdAt')" style="text-decoration:underline">DATA CREAZIONE</th>
                        <th @click="sort('N_FATTURA')" style="text-decoration:underline">NUMERO FATTURA</th>
                        <th @click="sort('CF')" style="text-decoration:underline">CODICE FISCALE</th>
                        <th @click="sort('DENOMINAZIONE_DITTA')" style="text-decoration:underline">DENOMINAZIONE</th>
                        <th @click="sort('METODO_IMPORTO')" style="text-decoration:underline">METODO DI PAGAMENTO</th>
                        <th @click="sort('DATA_ULTIMA_EMISSIONE')" style="text-decoration:underline">DATA TERMINE ULTIMA EMISSIONE</th>
                        <!-- <th>AUTORIZZAZIONE EMISSIONE</th> -->
                        <th>CREATA DA</th>
                        <th>STATO</th>
                        <th v-if="user_livello == 1 || user_livello == 2"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="valori in sortedNote" v-bind:key="valori.ID" class="row-color">
                        <td>{{getDate(getDateFromString(valori.createdAt))}}</td>
                        <td>{{valori.N_FATTURA}}</td>
                        <td>{{valori.CF}}</td>
                        <td>{{valori.DENOMINAZIONE_DITTA}}</td>
                        <td>{{valori.METODO_IMPORTO}}</td>
                        <td v-if="valori.DATA_ULTIMA_EMISSIONE!=null">{{getDate(valori.DATA_ULTIMA_EMISSIONE)}}</td>
                        <td v-else>-</td>
                        <!-- <td v-if=""></td>
                            se autorizzatata require("@/assets/img/blue.png")
                            se check emessa require("@/assets/img/green.png")
                            se non autorizzata require("@/assets/img/yellow.png")
                            se nota non più evitabile require("@/assets/img/red.png")
                         -->
                        <td v-if="valori.user != null">{{valori.user.NOME}} {{valori.user.COGNOME}}</td>
                        <td v-else></td>
                        <td>
                            <span v-if="valori.AUTORIZ_EMISSIONE == true && valori.EMISSIONE == true">
                                <img src="@/assets/img/green.png" style="width:20px">
                            </span>
                            <span v-if="valori.AUTORIZ_EMISSIONE == false || valori.EMISSIONE == false">
                                <img src="@/assets/img/red.png" style="width:20px">
                            </span>
                            <span v-if="valori.AUTORIZ_EMISSIONE == null && valori.EMISSIONE == null">
                                <img src="@/assets/img/blue.png" style="width:20px">
                            </span>
                            <span v-if="valori.AUTORIZ_EMISSIONE == true && valori.EMISSIONE == null">
                                <img src="@/assets/img/yellow.png" style="width:20px">
                            </span>
                        </td>
                        <td v-if="user_livello == 1 || user_livello == 2">
                            <router-link :to="'/modifica-nota?id='+valori.ID"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link>
                        </td>
                        <td v-else>
                            <router-link :to="'/modifica-nota?id='+valori.ID"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </card>
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import NoteServices from '@/services/NoteServices';
import Modal from "@/components/Modal.vue";
import moment from 'moment';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            searchModalVisible: false,
            // filtri
            stato_selected: null,
            dateFrom: null,
            dateTo: null,
            metodo_selected: null,
            filtroScelto: null,

            // per mostrare pagine
            n_righe: 15,
            page: 1,
            totPage: null,
        
            note_array: [],
            allNote: [],
            //form
            richiedente: null,
            ufficio: null,
            codice_fiscale: null,
            denominazione: null,
            numero_fattura: null,
            addebiti_stornare: null,
            causale_nota: null,
            importo: null,
            metodo: null,
            motivazione: null,
            data_ultima_emissione: null,
            if_storno: false,
            autorizzazione_emissione: null,
            sedi: [],

            showRisultati: false,
            //pop up per cercare 
            cerca_info: [],
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,

            cerca_info: [],
            access_token: null,
            token_response: [],
            user_livello: null,

            cerca_selezionato: 'denominazione',
            // per ordinare righe tabella
            currentSort:'ID',
            currentSortDir:'desc',

            urlRichieste: 'https://sviluppoallergeni.confcom.it/',
            note_status: [],
            accredito_creata: null,
            accredito_emessa: null,
            accredito_approvata: null,
            accredito_respinta: null,
        }
    },
    methods: {
        caricaNote: async function() {
            let errore = 0;
            // let accessToken = localStorage.getItem('access_token');
            await NoteServices.getNoteCredito()
            .then(response => { this.note_array = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();//await this.refreshToken();
                if (value) { await this.caricaNote(); }
            }
            console.log("tutte le note: ");
            console.log(this.note_array);
            this.allNote = this.note_array;
        },

        caricaPagina: async function(){
            let risposta;
            let errore = 0;
            await NoteServices.changePage(1, this.n_righe)
            .then(response => { risposta = response.data})
            .catch( async function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                    console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();//await this.refreshToken();
                if (value) { await this.caricaPagina(); }
            }
            this.note_array = risposta.rows;
            // Faciamo che ne mostro 15 per pagina
            var total = this.allNote.length;
            this.totPage = Math.ceil(total/this.n_righe);
        },

        cerca: async function() {
            let input, filter, table, tr, td, i, txtValue;
            input = document.getElementById("ricerca");
            filter = input.value.toUpperCase();
            table = document.getElementById("tabella");
            tr = table.getElementsByTagName("tr");
            let arrayFiltrato = [];
            for (i = 0; i < this.note_array.length; i++) {
                // txtValue = this.note_array[i].DENOMINAZIONE_DITTA;
                if (this.cerca_selezionato == "denominazione") {
                    txtValue = this.note_array[i].DENOMINAZIONE_DITTA;
                } else {
                    txtValue = this.note_array[i].user.COGNOME + this.note_array[i].user.NOME;
                }
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                arrayFiltrato.push(this.note_array[i]);
                }
            }
            this.note_array = arrayFiltrato;
            if (filter == "") {
                await this.main();
            }
        },

        changePage: async function(val){
            let risposta;
            let errore = 0;
            if(val == 'avanti'){
                this.page = this.page + 1;
            } else {
                //indietro
                this.page = this.page - 1;
            }
            await NoteServices.changePage(this.page, this.n_righe)
            .then(response => { risposta = response.data})
            .catch( async function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();//await this.refreshToken();
                if (value) { await this.changePage(val); }
            }
            this.note_array = risposta.rows;
        },

        // esportaCSV: async function() {
        //     let errore = 0;
        //     let risposta = [];
        //     await NoteServices.esportaFile()
        //     .then(response => { risposta = response.data})
        //     .catch( async function (error) {
        //         if(error.response.status == 401){
        //         errore = error.response.status;
        //         console.log(`errore = ${errore}`);
        //         }
        //     })
        //     if (errore == 401) {
        //         let value = await Services.refreshTokenFunction();
        //         if (value) { await this.esportaCSV(); }
        //     }
        //     console.log(`risposta esporta csv`);
        //     console.log(risposta);
        // },

        filtra: async function() {
            // <!--  
            // filtri:     filtraStato  dataTermine( dateFrom dateTo ) filtraAutorizzate filtraMetodoPagamento
            // variabili:  stato_selected   dateFrom   dateTo   metodo_selected  filtroScelto
            if (this.filtroScelto == 'filtraStato') {
                if (this.stato_selected == 'autorizzata') {
                    let arrayFiltrato = this.allNote.filter( (el) => { return el.AUTORIZ_EMISSIONE == true });
                    let arrayFiltratoNonEmesse = arrayFiltrato.filter((el) => { return el.EMISSIONE == null });
                    this.note_array = arrayFiltratoNonEmesse;
                } else if (this.stato_selected == 'non_autorizzata') {
                    let arrayFiltrato = this.allNote.filter( function (el) { return el.AUTORIZ_EMISSIONE == false || el.EMISSIONE == false });
                    this.note_array = arrayFiltrato;
                } else if (this.stato_selected == 'non_ancora_autorizzata') {
                    let arrayFiltrato = this.allNote.filter( (el) => { return el.AUTORIZ_EMISSIONE == null });
                    this.note_array = arrayFiltrato;
                } else if (this.stato_selected == 'emessa') {
                    let arrayFiltrato = this.allNote.filter( function(el) { return el.AUTORIZ_EMISSIONE == true && el.EMISSIONE == true });
                    // let arrayFiltratoEmesse = arrayFiltrato.filter((el) => { return el.EMESSA == true });
                    this.note_array = arrayFiltrato;
                } else {
                    await this.caricaNote();
                }
            } else if ( this.filtroScelto == 'dataTermine') {
                let dataFrom = this.dateFrom;
                let dataTo = this.dateTo;
                let arrayFiltratoFrom = this.allNote.filter( (el) => { return el.DATA_ULTIMA_EMISSIONE >= dataFrom });
                let arrayFiltratoTo = arrayFiltratoFrom.filter( (el) => { return el.DATA_ULTIMA_EMISSIONE <= dataTo });
                this.note_array = arrayFiltratoTo;
            } else if ( this.filtroScelto == 'filtraAutorizzate') {
                let arrayFiltrato = this.allNote.filter((el) => {return el.AUTORIZ_EMISSIONE == true });
                this.note_array = arrayFiltrato;
            } else if ( this.filtroScelto == 'filtraMetodoPagamento') {
                let arrayFiltrato = this.allNote.filter((el) => { return el.METODO_IMPORTO == this.metodo_selected });
                this.note_array = arrayFiltrato;
            } else {
                await this.caricaNote();
            }
        },

        //OK
        filterByStatus: function(value) {
            this.filtroScelto = 'filtraStato';
            this.stato_selected = value;
            this.filtra();
        },

        getDate(date) {
            return moment(String(date)).format('DD/MM/YYYY');
        },

        getStatus: async function() {
            let errore = 0;
            await NoteServices.getStatusNote()
            .then(response => { this.note_status = response.data})
            .catch( async function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                console.log(`errore = ${errore}`);
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getStatus(); }
            }
            console.log(this.note_status);
            this.accredito_creata = this.note_status.ACCREDITO_creata;
            this.accredito_emessa = this.note_status.ACCREDITO_emessa;
            this.accredito_approvata = this.note_status.ACCREDITO_approvata;
            this.accredito_respinta = this.note_status.ACCREDITO_respinta;
        },

        getDateFromString: function(datetime) {
            // let datetime = "2021-12-05T22:01:00.000Z"; //createdAt: "2022-03-03T07:37:41.000Z
            const arr =  datetime.split(":");
            const date = arr[0].split('T');
            return date[0];
        },

        // non serve più
        refreshToken: async function(){
            let errore = 0;
            await Services.refreshToken()
            .then(response => { this.token_response = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 403){
                    errore = error.response.status;
                } else if (error.response.status == 401) {
                    errore = error.response.status;
                }
            });
            console.log(`errore fuori da catch refreshToken = ${errore}`);
            if(errore == 403 || errore == 401){
                console.log(`errore = ${errore} -> fai logout`);
                await this.logout();
                return false;
            } 
            localStorage.setItem('access_token', this.token_response.accessToken);
            return true;
        },

        sort:function(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc' ? 'desc' : 'asc';
            }
            this.currentSort = s;
        },
        
        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            axios.defaults.withCredentials = true;
            this.access_token = localStorage.getItem('access_token');
            try {
                await this.caricaNote();
                await this.caricaPagina();
                await this.getStatus();
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                // console.log(`error.response try/catch = ${error.response}`);
                // console.log(`error.response.status try/catch = ${error.response.status}`);
                if (error.response.status == 401) {
                    // await this.refreshToken();
                    await Services.refreshTokenFunction();
                }
            }
        }
    },

    mounted() {
        this.main();
    },
    computed:{
        sortedNote:function() {
            return this.note_array.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            });
        },
    }
  };
</script>
<style>
</style>
  